<template>
  <div class="base-setup" @click="showIconSelect = false">
    <a-form :form="form" ref="baseSetting" :model="setup" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
      <a-form-item label="主体企业" v-if="this.$route.query.code !== undefined">
        <span>{{ setup.host_corporation }}</span>
      </a-form-item>
      <a-form-item label="主体企业" v-if="this.$route.query.code === undefined">
        <a-select
          v-decorator="['host_corporation_id', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
          option-label-prop="tt"
          :filter-option="false"
          show-search
          allow-clear
          placeholder="请选择主体企业"
          :not-found-content="loading ? undefined : null"
          @search="this.handleTradeHostCorporation"
          @change="tradeProjectChange"
        >
          <a-spin v-if="loading" slot="notFoundContent" />
          <a-select-option v-for="(wc, index) in hostCorporationList" :tt="wc.name" :key="index" :value="wc.id">
            {{ wc.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="审批名称" prop="template_name">
        <a-input
          v-decorator="['template_name', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
          placeholder="请输入名称"
          :max-length="18" />
      </a-form-item>
      <a-form-item label="所属分类">
        <a-select
          v-decorator="['trade_type', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
          option-label-prop="tt"
          placeholder="选择审批所属分类"
          allow-clear>
          <a-select-option v-for="(value, key, index) in this.$Dictionaries.trade_approve_type" :tt="value" :key="index" :value="key">
            {{ value }}
          </a-select-option>
        </a-select>
        <a-input
          v-if="false"
          v-model="setup.settings.notify.title"
          style="width: 68%; float:right;"
          placeholder="消息通知标题"></a-input>
      </a-form-item>
      <a-form-item label="表单说明">
        <a-textarea
          placeholder="请输入表单说明"
          :auto-size="{ minRows: 4, maxRows: 5 }"
          v-model="setup.remark">
        </a-textarea>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import { corporation_list } from '@/api/trade_corporation'
import pick from 'lodash.pick'

export default {
  name: 'FormBaseSetting',
  data () {
    this.handleTradeHostCorporation = debounce(this.handleTradeHostCorporationSearch, 800)
    return {
      form: this.$form.createForm(this, { name: 'tradeApproveTemplate' }),
      loading: false,
      nowUserSelect: null,
      select: [],
      newGroup: '',
      hostCorporationList: []
    }
  },
  computed: {
    setup () {
      return this.$store.state.tradeApprove.design
    }
  },
  mounted () {
    this.handleTradeHostCorporationSearch(undefined)
    this.initFormData()
  },
  methods: {
    handleTradeHostCorporationSearch (query) {
      this.loading = true
      corporation_list({ name: query }).then(rsp => {
        this.hostCorporationList = rsp.data.entries
      }).catch(err => this.$message.error('获取项目异常:' + err.response.data)).finally(() => {
        this.loading = false
      })
    },
    initFormData () {
      const fields = ['host_corporation_id', 'template_name', 'trade_type']
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      new Promise((resolve) => {
        setTimeout(resolve, 1000)
      }).then(() => {
        console.log('------', this.setup)
        const data = {
          host_corporation_id: this.setup.host_corporation_id,
          template_name: this.setup.template_name,
          trade_type: this.setup.settings.notify.types
        }
        const formData = pick(data, fields)
        console.log('formData', formData)
        this.id = formData.id
        form.setFieldsValue(formData)
      })
    },
    tradeProjectChange (value) {
      if (value === undefined) {
        this.handleTradeHostCorporationSearch(undefined)
      }
    },
    selected (select) {
      this.$set(this.setup.settings, this.nowUserSelect, select)
    },
    selectUser (key) {
      this.select = this.setup.settings[key]
      this.nowUserSelect = key
    },
    validate () {
      const form = this.$refs.baseSetting.form
      const errorList = []
      form.validateFields((errors, values) => {
        if (errors) {
          errorList.push(errors)
        } else {
          if (this.$route.query.code === undefined) {
            this.setup.host_corporation_id = values['host_corporation_id']
          }
          this.setup.template_name = values['template_name']
          this.setup.settings.notify.types = values['trade_type']
        }
      })
      return errorList
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-select-dropdown {
  display: none;
}

.icon-select {
  display: flex;
  flex-wrap: wrap;

  i {
    cursor: pointer;
    font-size: large;
    padding: 10px;
    max-width: 38px !important;

    &:hover {
      box-shadow: 0 0 10px 2px #C2C2C2;
    }
  }
}

/deep/ .select-u {
  width: 100%;
}

.base-setup {
  overflow: auto;
  margin: 0 auto;
  width: 100%;
  height: calc(100vh - 105px);
  background: #ffffff;
  margin-top: 10px;
  padding: 15px 20px;

  i:first-child {
    position: relative;
    cursor: pointer;
    font-size: xx-large;
    color: #ffffff;
    border-radius: 10px;
    padding: 10px;
  }

  .change-icon {
    margin-left: 20px;

    span {
      font-size: small;
      color: #7a7a7a;
      margin-right: 15px;
    }

    i {
      cursor: pointer;
      color: #7a7a7a;
      font-size: x-large;
    }
  }

  /deep/ .el-form-item__label {
    padding: 0;
    font-weight: bold;
  }

  /deep/ .el-form-item {
    margin-bottom: 5px;
  }
}

/deep/ .group {
  .el-select {
    width: calc(100% - 130px);
  }

  .el-button {
    margin-left: 10px;
    width: 120px;
  }
}

::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  background-color: #f8f8f8;
}

::-webkit-scrollbar-thumb {
  border-radius: 16px;
  background-color: #e8e8e8;
}
</style>
